"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpandableContainer = exports.ExpandableCard = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
exports.ExpandableCard = styled_1.default.div `
  background: ${(0, ui_theme_1.fromTheme)('color_background')};
  padding: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  border-radius: ${(0, ui_theme_1.fromTheme)('provider_profile_border_radius')};
  border: ${(0, ui_theme_1.fromTheme)('provider_profile_border_style')}
    ${(0, ui_theme_1.fromTheme)('provider_profile_color_border')}
    ${(0, ui_theme_1.fromTheme)('provider_profile_border_width')};
  box-shadow: ${(0, ui_theme_1.fromTheme)('provider_profile_box_shadow')};
  -webkit-box-shadow: ${(0, ui_theme_1.fromTheme)('provider_profile_box_shadow')};
  -moz-box-shadow: ${(0, ui_theme_1.fromTheme)('provider_profile_box_shadow')};

  > button {
    margin-top: ${(0, ui_theme_1.fromTheme)('spacing_large')};

    @media print {
      display: none;
    }
  }
`;
exports.ExpandableContainer = styled_1.default.div `
  max-height: ${(props) => props.isExpandable ? `${props.containerHeight}px` : 'none'};
  overflow: hidden;
  position: relative;

  div.provider-insurances {
    padding: 0;
    margin: 0;
    border: none;
  }

  ${(props) => props.isExpandable
    ? `
      ::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 30px;
        pointer-events: none;
        background: transparent;
        transition: background 1s;
        background: linear-gradient(
          180deg,
          rgba(255, 255, 255, 0) 0%,
          ${(0, ui_theme_1.fromTheme)('color_background')(props)} 100%
        );
      }
      `
    : ''}
`;
//# sourceMappingURL=styles.js.map